const Logo = (props) => (
  <img alt="Logo" src="/static/lux-touch-logo.png" {...props} />
);

export default Logo;
